import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const success = await login(username, password);
    if (!success) {
      setError("Invalid credentials");
    } else {
      localStorage.setItem("adminName", username);
    }
    setIsLoading(false);
  };

  if (isAuthenticated) {
    // Redirect to the page they tried to visit or dashboard
    const from = location.state?.from || "/dashboard";
    return <Navigate to={from} replace />;
  }

  return (
    <div
      className="hero is-fullheight"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="hero-body">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-4">
              <div
                className="neumorphic p-6"
                style={{ background: "var(--bg-secondary)" }}
              >
                <div className="has-text-centered mb-6">
                  <span className="icon is-large">
                    <FontAwesomeIcon
                      icon={faGraduationCap}
                      size="3x"
                      style={{ color: "var(--accent-primary)" }}
                    />
                  </span>
                  <h1
                    className="title is-4 mt-4"
                    style={{ color: "var(--text-primary)" }}
                  >
                    Studizy Admin
                  </h1>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium neumorphic-inset"
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium neumorphic-inset"
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {error && (
                    <div className="notification is-danger is-light">
                      {error}
                    </div>
                  )}

                  <button
                    className={`button is-primary is-fullwidth neumorphic ${
                      isLoading ? "is-loading" : ""
                    }`}
                    type="submit"
                    disabled={isLoading}
                  >
                    Log in
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
